import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { useSnackbar } from "notistack";

const UpdateMostSaleProduct = () => {
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    image: null,
  });

  const [imagePreview, setImagePreview] = useState(null);
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const { id } = useParams();
  const URL = process.env.REACT_APP_URL;

  useEffect(() => {
    const fetchProductDetails = async () => {
      try {
        const response = await axios.get(`${URL}mostproduct/${id}`);
        const { title, description, image } = response.data;

        setFormData({ title, description, image: null });
        setImagePreview(`${URL}upload/${image}`);
      } catch (error) {
        enqueueSnackbar("Failed to fetch product details.", {
          variant: "error",
        });
      }
    };

    fetchProductDetails();
  }, [id, URL, enqueueSnackbar]);

  const handleInputChange = (e) => {
    const { name, value, files } = e.target;

    if (files && files.length > 0) {
      const newImage = files[0];

      if (!newImage.type.startsWith("image/")) {
        enqueueSnackbar("Please upload a valid image file.", {
          variant: "error",
        });
        return;
      }

      if (newImage.size > 5 * 1024 * 1024) {
        enqueueSnackbar("File size must be less than 5MB.", {
          variant: "error",
        });
        return;
      }

      setFormData((prev) => ({ ...prev, image: newImage }));

      const reader = new FileReader();
      reader.onloadend = () => setImagePreview(reader.result);
      reader.readAsDataURL(newImage);
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = new FormData();
    Object.keys(formData).forEach((key) => {
      if (formData[key]) {
        data.append(key, formData[key]);
      }
    });

    try {
      const response = await axios.post(`${URL}mostproduct/${id}`, data, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.status === 200) {
        enqueueSnackbar("Product updated successfully!", {
          variant: "success",
        });
        navigate("/mostProduct");
      } else {
        enqueueSnackbar("Failed to update product.", { variant: "error" });
      }
    } catch (error) {
      enqueueSnackbar(error.response?.data?.error || "Something went wrong.", {
        variant: "error",
      });
    }
  };

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white shadow-lg rounded-lg">
      <h2 className="text-2xl font-semibold mb-6 text-gray-700">
        Update Most Sale Product
      </h2>
      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <label
            htmlFor="title"
            className="block text-sm font-medium text-gray-700"
          >
            Title
          </label>
          <input
            type="text"
            id="title"
            name="title"
            className="mt-1 block w-full p-2 border border-gray-300 rounded-lg focus:ring-indigo-500 focus:border-indigo-500"
            value={formData.title}
            onChange={handleInputChange}
            required
          />
        </div>

        <div>
          <label
            htmlFor="description"
            className="block text-sm font-medium text-gray-700"
          >
            Description
          </label>
          <textarea
            id="description"
            name="description"
            className="mt-1 block w-full p-2 border border-gray-300 rounded-lg focus:ring-indigo-500 focus:border-indigo-500"
            value={formData.description}
            onChange={handleInputChange}
            required
          />
        </div>

        <div>
          <label
            htmlFor="image"
            className="block text-sm font-medium text-gray-700"
          >
            Product Image
          </label>
          <input
            type="file"
            id="image"
            name="image"
            className="mt-1 block w-full p-2 border border-gray-300 rounded-lg focus:ring-indigo-500 focus:border-indigo-500"
            accept="image/*"
            onChange={handleInputChange}
          />
          {imagePreview && (
            <div className="mt-3">
              <img
                src={imagePreview}
                alt="Preview"
                className="w-32 h-32 object-cover rounded-lg"
              />
            </div>
          )}
        </div>

        <button
          type="submit"
          className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500"
        >
          Update Product
        </button>
      </form>
    </div>
  );
};

export default UpdateMostSaleProduct;
